import React, { useEffect, useRef, useState } from 'react';

import styles from './Dropdown.module.scss';
import classNames from 'classnames';

export interface DropdownProps {
  options: any[];
  onChange?: Function;
  prefix?: Function;
  arialabelledby?: string;
  placeholder?: string;
  zIndex?: number;
  error?: string;
  setFieldValue?: Function;
  callback?: Function;
  name?: string;
  id?: string;
  isDisabled?: boolean;
  value?: { //for default value using cookie
    label: string;
    value: string;
  };
}

export const Dropdown = (props: DropdownProps) => {
  const [isOpenList, setIsOpenList] = useState(false);
  const [optionList, setOptionList] = useState(undefined);
  const optionRef = useRef<HTMLDivElement>();

  const handleInputChange = (event: any) => {
    event.preventDefault();
    const currEl = optionRef.current;
    const inputTxtNode = currEl?.getElementsByTagName('label');
    inputTxtNode.length > 0 && inputTxtNode[0].setAttribute('style', 'visibility:hidden');

    const filterList  = props.options.filter((item : { 
      label: string;
      value: string;
    }) => item.label.toUpperCase().indexOf((event.target.value as string).toUpperCase()) >= 0);
    
		setOptionList(filterList);
    !isOpenList && setIsOpenList(true);
	}

  const handleOptionClick = async (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    setOptionList(props.options);
    setIsOpenList(false);
    
    const v = { 'label' : event.target.getAttribute('data-name'), 'value' : event.target.getAttribute('data-id') };
    await props.callback(v); 

    const currEl = optionRef.current;
    const inputTxtNode = currEl?.getElementsByTagName('label');
    const inputCurrEl = currEl?.getElementsByTagName('input');

    inputTxtNode?.length > 0 && inputTxtNode[0].setAttribute('style', 'visibility:visible');    
    if (inputCurrEl?.length > 0) {
      inputCurrEl[0].value = '';
    }
  }

  const handleControlClick = () => {
    if (!props.isDisabled) {
      const inputCurrEl = optionRef?.current.getElementsByTagName('input');
      if (inputCurrEl?.length > 0) {
        inputCurrEl[0].focus;
        inputCurrEl[0].setSelectionRange(0,0);
      }

      setOptionList(props.options);
      setIsOpenList(!isOpenList);      
    }
  }

  const clickListener = (event : MouseEvent) => {
    const currEl = optionRef.current;
    const targetEl = event.target;
    if (!currEl.contains(targetEl as any)) { 
      setIsOpenList(false);
    } 
  }

  const blurListener = () => {
    setIsOpenList(false);
  }

  useEffect(() => {
    document.addEventListener('click', clickListener);
    window.addEventListener('blur', blurListener);

    return () => {
      document.removeEventListener('click', clickListener);
      window.removeEventListener('blur', blurListener);
    }
  },[]);
  
  return (
    <div ref={optionRef} className={styles.wrapper} style={{ zIndex: props.zIndex }}>
      <div className={styles.wrapper}>
        <div className={classNames(styles.wrapper_control, isOpenList && styles.active_select, props.isDisabled && styles.wrapper_control_disabled)} onClick={handleControlClick}>
          <div className={styles.wrapper_input_group}>
            <div className={styles.wrapper_input_group_input}>
              <div style={{display:'inline-block'}}>
                <input 
                  type="text" 
                  id={props.id} 
                  name={props.name} 
                  onChange={handleInputChange}
                  autoCapitalize="none" 
                  autoComplete="off" 
                  autoCorrect="off" 
                  spellCheck="false" 
                  tabIndex={0} 
                  aria-autocomplete="list" 
                  aria-labelledby={props.name}
                  disabled={props.isDisabled}
                />
              </div>
            </div>            
            <label htmlFor={props.id} className={styles.wrapper_input_group_txt}>{props.value?.value ? props.value?.label : props.placeholder + '...'}</label> 
          </div>
          <div className={isOpenList ? styles.arrow_up : styles.arrow_down}></div>
        </div>
      </div>
      
      { isOpenList &&     
        <div className={styles.wrapper_input_group_list}>
          {optionList && optionList.length > 0 && optionList.map((opt) => 
            (<div key={`option_${props.name +'_'+ opt.value}`} className={classNames(styles.option, `${props.value?.value == opt.value ? styles.active_option : ''}`)} data-id={opt.value} data-name={opt.label} onClick={handleOptionClick}>{opt.label}</div>)
          )}

          { optionList?.length == 0 && <div className={styles.no_option}>{'Tidak Ada Pilihan'}</div>}
        </div>
      }
      {props.prefix && props.prefix()}
      {props.error && <p className={classNames(styles.help, 'error-message')}>{props.error}</p>}
    </div>
  );
};